import { MakeCall } from './createMakeCall';
import { APIV2_URL } from './constants';

export interface PartnerClickData {
  identity: string;
  eventTime: string;
}

export interface PartnerListingClick {
  url: string;
  signature: string;
}

const generateListingClick =
  (makeCall: MakeCall) => (listingId: number, data: PartnerClickData) =>
    makeCall<PartnerListingClick>(
      'POST',
      `${APIV2_URL}/listing/${listingId}/generate-click`,
      { data },
    );

export default generateListingClick;
